import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/CurrentThankYouPage.head';
import { CurrentThankYouPage } from '@pages/CurrentThankYouPage';

export const Route = createFileRoute('/current-thank-you')({
  component: CurrentThankYouPage,
  head: () => head,
});
